import React, { useEffect, useState } from 'react';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { products_list } from '../services/Product-service';
import { Link } from 'react-router-dom';
import { formatPrice } from "../utils/formatPrice";

function ShopTheLook({ showshopthelook, sectionTitle }) {
    const [productArr, setProductArr] = useState([]);
    const totalItems = productArr.length;
    const desktopSlidesToShow = 5;

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
        slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
                    infinite: false,
                    arrows: true,
                    dots: false
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: Math.min(2, totalItems || 1),
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: false,
                    dots: false,
                    swipeToSlide: true,
                    touchThreshold: 8,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: Math.min(2, totalItems || 1),
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: false,
                    dots: false,
                    swipeToSlide: true,
                    touchThreshold: 8
                }
            }
        ]
    };

    const getProductList = () => {
        products_list({
            offset: 0,
            occasion_id: 99,
        }).then((data) => {
            setProductArr((data.products || []).slice(0, 8));
        }).catch((error) => {
            console.error("Error fetching data list:", error);
        })
    }

    useEffect(() => {
        if (!showshopthelook) return;
        getProductList();
    }, [showshopthelook])

    if (!showshopthelook || totalItems === 0) return null;

  return (
    <div>
         <div className='App'>
                <div className="BreakPointContainer">
                    <div className="CarouselSectionContainer shop-the-look">
                        <div className="layout row justify-space-between align-center text-left SectionTitle">
                            <h1 className='m-t-0 m-b-0 demi-bold w-auto'> {sectionTitle || 'SHOP THE LOOK'} </h1>
                            <Link to="/category/?occasion_id=99" className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'>VIEW ALL</Link>
                        </div>
                        <div className="layout">
                            <div className="flex left-align-slick xs12">
                            <Slider {...settings}>
                                    {productArr.map((data, index) => (
                                        <div className='item sjl' key={data.id || index}>
                                        <div className="CarouselSection category">
                                            <div className="prel Gutter">
                                            <Link to={`/products/productdetails/${data.id}`}>
                                                    <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '112%' }}>
                                                        <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '32%' }}>
                                                            <img src={data.product_thumbail} alt={data.product_title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
                                                        </div>
                                                        <div className="animated-bg-placeholder"></div>
                                                    </div>
                                                    <div className="ImageTextDetail ProductImageTextDetail">
                                                        <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold"> {data.product_title} </label>
                                                        <label className="h6 ellipsis-two-line font-normal ImageTextLabelBottom block font-normal">{data.product_short_description}</label>
                                                        <div className="ProductPrice layout row wrap">
                                                            <span className='SpecialPrice p2 demi-bold w-auto p-0 detail_spc' style={{ marginLeft: '5%' }}>
                                                                ₹{formatPrice((data?.saleprice > 0 ? data.saleprice : data.price), { showSymbol: false })}
                                                            </span>
                                                            {data?.discount_amount > 0 && (<span className='InitialPrice p3 w-auto p-0'> ₹{formatPrice(data?.price, { showSymbol: false })} </span>)}
                                                            <span className='DiscountPriceRound p3 w-auto p-0'>
                                                                {data?.discount_type == 'flat' ? `${data?.discount_amount} FLAT OFF` : ''}
                                                                {data?.discount_type == 'percentage' ? `${data?.discount_amount}% OFF` : ''} </span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                   ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default ShopTheLook
